module.exports = __webpack_public_path__ + "media/effects-19.3a960308.webm";